import { CSSProperties } from "react";

export function getLoginStreakLevel(loginStreak: number) {
    if (loginStreak < 5) {
        return 1;
    }
    if (loginStreak < 10) {
        return 2;
    }
    if (loginStreak < 15) {
        return 3;
    }
    if (loginStreak < 30) {
        return 4;
    }
    if (loginStreak < 60) {
        return 5;
    }
    if (loginStreak < 100) {
        return 6;
    }
    if (loginStreak < 365) {
        return 7;
    }
    return 8;
}

const streakIcons = ["🚶", "🏃", "🚴", "🚗", "🏎️", "✈️", "🚀", "🛸"] as const;

export function LoginStreakText({
    loginStreak,
    innerStyle,
}: {
    loginStreak: number;
    innerStyle?: CSSProperties;
}) {
    const streakLevel = getLoginStreakLevel(loginStreak);
    const icon = (
        <div
            style={{
                fontSize: "large",
                backgroundColor: "white",
                borderRadius: "50%",
                minWidth: 27,
                height: 27,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
            className="reverseDarkMode"
        >
            {streakIcons[streakLevel - 1]}
        </div>
    );

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 5,
                width: "100%",
                ...innerStyle,
            }}
        >
            {icon}

            <span>
                <span style={{ whiteSpace: "nowrap" }}>Login Streak:</span>{" "}
                <span style={{ whiteSpace: "nowrap" }}>
                    {loginStreak} {loginStreak === 1 ? "day" : "days"}
                </span>
            </span>

            {icon}
        </div>
    );
}
